import { MouseEvent, FC } from 'react';
// Redux
import { useAppDispatch } from 'hooks/useStore';
import { appActions } from 'store/app/appSlice';
import PageTypes from 'types/PageTypes';
// Components
import Icon from 'components/Icon';
import { IconButton } from 'components/Buttons';
import { Tooltip } from 'components/Tooltip';
// Icons
import { MdDragIndicator } from 'react-icons/md';
// i18next
import { useTranslation } from 'react-i18next';
// Utilities
import { expandAccordion } from 'utilities/utilities';

type Props = {
  menuItem: any;
  onDelete?: () => void;
  onCopy?: () => void;
  active: boolean;
  error?: boolean;
  dragIcon?: boolean;
  clicable?: boolean;
  forceExpande?: boolean;
}

const MenuItem:FC<Props> = ({
  // Props
  menuItem, onDelete, onCopy, active, error, dragIcon = false, clicable = true, forceExpande = false
}) => {
  const { t } = useTranslation();
  
  const dispatch = useAppDispatch();

  const handeClick = () => {
    dispatch(appActions.setQuizFormMenuItem(menuItem.value));
    if (forceExpande) expandAccordion(menuItem.value);
    dispatch(appActions.toggleQuizFormSidebar());
  }

  const handleDelete = (event:MouseEvent<HTMLButtonElement> | undefined) => {
    if ( event ) event.stopPropagation();
    if ( typeof onDelete !== 'undefined' ) onDelete();
  }

  const handleCopy = (event:MouseEvent<HTMLButtonElement> | undefined) => {
    if ( event ) event.stopPropagation();
    if ( typeof onCopy !== 'undefined' ) onCopy();
  }

  const classes = active
    ? 'bg-primary-light text-primary'
    : 'text-white'
  ;

  const [type]:[PageTypes] = menuItem.value.split('-');

  const pageTypeLabel:Record<PageTypes, string> = {
    [PageTypes.Banner]: t('labels.interstitial'),
    [PageTypes.Question]: t('labels.question'),
    [PageTypes.AdditionalQuestions]: t('labels.additionalQuestion'),
    [PageTypes.Timer]: t('labels.timer'),
    [PageTypes.Waiting]: t('labels.waiting'),
  };

  return (
    <div
      className={`
        ${classes}
        flex items-center gap-2
        rounded-xl
        ${clicable ? 'hover:bg-primary-light cursor-pointer' : ''}
        ${dragIcon ? 'py-4 px-2' : 'p-4'}
      `}
      onClick={handeClick}
    >
      {dragIcon && (
        <IconButton onClick={() => {}}>
          <MdDragIndicator />
        </IconButton>
      )}
      {menuItem.icon ? <Icon icon={menuItem.icon} /> : null}
      <span className="flex-grow text-base text-left">{menuItem.label}</span>
      {error ? (
        <Icon
          className="text-red-500"
          icon="error_outline"
        />
      ) : null}
      <div className="flex items-center">
        {typeof onCopy !== 'undefined' && (
          <Tooltip title={`${t('buttons.copy')} ${pageTypeLabel[type]}`}>
            <IconButton onClick={handleCopy}>
              <Icon icon="content_copy" size="small" />
            </IconButton>
          </Tooltip>
        )}
        {typeof onDelete !== 'undefined' && (
          <Tooltip title={`${t('buttons.delete')} ${pageTypeLabel[type]}`}>
            <IconButton onClick={handleDelete}>
              <Icon icon="delete" />
            </IconButton>
          </Tooltip>
        )}
      </div>
    </div>
  )
}

export default MenuItem;
